<template>
  <div class="bg-neutral100 h-[1.375rem] rounded animate-pulse" />
</template>
